const routes = [
	{
		path: 'home',
		name: 'admin-home',
		component: () => import('@/views/admin/AdminHome'),
		meta: {
			title: 'News & Links',
			icon: 'mdi-view-dashboard',
			contentId: 'home'
		}
	},
	{
		path: 'about',
		component: () => import('@/views/admin/AdminAbout'),
		meta: {
			title: 'About',
			icon: 'mdi-information',
			subheader: true,
			subtitle: 'Content Management',
			contentId: 'about'
		}
	},
	
	{
		path: 'providers',
		component: () => import('@/views/admin/AdminProviders'),
		meta: {
			title: 'Hydrographic Offices',
			icon: 'mdi-import',
			contentId: 'providers'
		}
	},
	{
        path: 'buildFund',
        component: () => import('@/views/admin/AdminBuildFund'),
        meta: {
            title: 'Capacity Building Fund',
            icon: 'mdi-information-outline',
			subheader: true,
            contentId: 'buildFund'
        }
    },
	{
		path: 'distributors',
		component: () => import('@/views/admin/AdminDistributors'),
		meta: {
			title: 'Distributors',
			icon: 'mdi-export',
			contentId: 'distributors'
		}
	},
	{
		path: 'S100',
		component: () => import('@/views/admin/AdminS100'),
		meta: {
			title: 'S-100',
			icon: 'mdi-information',
			subheader: true,
			subtitle: 'Content Management',
			contentId: 'S100'
		}
	},
	{
		path: 'media',
		component: () => import('@/views/admin/AdminMedia'),
		meta: {
			title: 'Media',
			icon: 'mdi-folder-multiple-image',
			contentId: 'media'
		}
	},
	{
		path: 'contact',
		component: () => import('@/views/admin/AdminContact'),
		meta: {
			title: 'Contact',
			icon: 'mdi-email',
			contentId: 'contact'
		}
	},
	{
		path: 'updates',
		component: () => import('@/views/admin/AdminTextPage'),
		meta: {
			title: 'T&P Updates',
			icon: 'mdi-information-outline',
			contentId: 'temporary-preliminary'
		}
	},
	{
		path: 'ecdis',
		component: () => import('@/views/admin/AdminTextPage'),
		meta: {
			title: 'ECDIS Mandate',
			icon: 'mdi-information-outline',
			contentId: 'ecdis-mandate'
		}
	},
	{
		path: 'users',
		component: () => import('@/views/admin/AdminUsers'),
		meta: {
			title: 'User Administration',
			icon: 'mdi-account-box',
			hideInNavbar: true,
			noPublicSwitcher: true
		}
	}
]

export default routes